var Backbone = require('backbone'),
    NoteSortComparators = require('../models/comparators');


module.exports = Backbone.Model.extend({

    defaults: {
        comparatorKey: 'ctime', // valid values are the keys in comparators
        sortDir: 'desc' // 'asc' or 'desc'
    },

    /*
     * If for some reason invalid attributes are passed from local storage
     * ( maybe they changed between versions )
     * set the model with it's default to avoid errors.
     * Basically 'validate' values that aren't undefined/null that would be set by defaults.
     */
    constructor: function( attributes , options ) {

        var attrs = attributes || {};

        if ( attrs.hasOwnProperty('comparatorKey') ) {

            var validComparators =  _.keys( NoteSortComparators );
            if ( ! _.contains( validComparators, attrs.comparatorKey ) )
                attrs.comparatorKey = this.defaults.comparatorKey;

        }

        if ( attrs.hasOwnProperty('sortDir') ) {
            if ( ! _.contains( [ 'asc', 'desc' ] , attrs.sortDir ) )
                attrs.sortDir = this.defaults.sortDir;
        }

        return Backbone.Model.prototype.constructor.call( this, attrs, options );

    },

    setComparator: function(comparator) {
        this.set('comparatorKey', comparator);
    },

    toggleDirection: function() {
        this.set( 'sortDir', this.get('sortDir')  === 'desc' ? 'asc' : 'desc' );
    },

    getSortType: function() {
        return this.get('comparatorKey');
    },

    getSortDirection: function() {
        return this.get('sortDir');
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/state/sortState.js
 ** module id = 521
 ** module chunks = 0
 **/